import { useFilters } from "core/features/filters/store";
import { AdvancedFiltersProps } from "../components/concentracao-colheita";

const useAdvancedFiltersConcentracaoColheita = () => {
  const { updateFiltroConcentracaoColheita, filters } = useFilters();
  const { filtroConcentracaoColheita } = filters;

  const filterSafraPeriodos = filtroConcentracaoColheita?.safraPeriodos;

  const applyFilters = (
    advancedFilters: AdvancedFiltersProps,
    handleCloseModal: () => void
  ) => {
    updateFiltroConcentracaoColheita(
      {
        safraPeriodos: advancedFilters.safraPeriodos,
      },
      true
    );
    handleCloseModal();
  };

  const clearFilters = (
    handleResetFiltersState: (advancedFilters: AdvancedFiltersProps) => void
  ) => {
    updateFiltroConcentracaoColheita(
      {
        safraPeriodos: [],
      },
      true
    );
    handleResetFiltersState({
      safraPeriodos: [],
    });
  };

  return {
    items: {
      filterSafraPeriodos,
    },
    onChange: applyFilters,
    clearFilters,
  };
};

export default useAdvancedFiltersConcentracaoColheita;
